import NiceModal from '@ebay/nice-modal-react'
import { MapIcon, PencilSquareIcon } from '@heroicons/react/24/outline'
import { Button, Card, Col, DateInput, Dropdown, Grid, Input, Spinner, Table } from 'components/gsys-ui'
import { PaginatedTable } from 'components/gsys-ui/Table/Table'
import moment from 'moment'
import { useEffect, useRef, useState } from 'react'
import { usePodCustomers, usePodDrivers, usePods } from 'util/queries'

const Pods = () => {
  const [{ pageIndex }, setPagination] = useState({ pageIndex: 0, pageSize: null })
  const tableContainerRef = useRef(null)
  const [pageSize, setPageSize] = useState(null)
  const [invoiceNo, setInvoiceNo] = useState('')
  const [selectedCustomer, setSelectedCustomer] = useState(null)
  const [selectedDriver, setSelectedDriver] = useState(null)
  const { isLoading, isError, error, data } = usePods({ pageIndex, pageSize, invoiceNo, acct: selectedCustomer?.value, driver: selectedDriver?.value }, { keepPreviousData: true, enabled: !!pageSize })

  useEffect(() => {
    if (!tableContainerRef.current) return
    setPageSize(Math.floor((tableContainerRef.current.offsetHeight - 79) / 33))
  }, [tableContainerRef])

  const handleInvoiceNo = (v) => {
    setPagination({ pageIndex: 0, pageSize: null })
    setInvoiceNo(v)
  }

  const handleCustomer = (v) => {
    setPagination({ pageIndex: 0, pageSize: null })
    setSelectedCustomer(v)
  }

  const handleDriver = (v) => {
    setPagination({ pageIndex: 0, pageSize: null })
    setSelectedDriver(v)
  }

  return (
    <Grid gap={7} className="p-2 h-full">
      <Col sm={24}>
        <Card className="h-full">
          <div className="flex flex-col h-full">
            <div className="flex flex-none m-2 space-x-2">
              <div className="w-[300px]">
                <CustomerDropdown
                  value={selectedCustomer}
                  onChange={handleCustomer}
                />
              </div>
              <div className="w-[200px]">
                <DriverDropdown
                  value={selectedDriver}
                  onChange={handleDriver}
                />
              </div>
              <div className="w-[200px]">
                <Input
                  placeholder="Enter invoice number..."
                  value={invoiceNo}
                  onChange={(e) => handleInvoiceNo(e.target.value)}
                />
              </div>
              {/*<div className="w-[200px]">
              <DateInput
                placeholder="Select start date..."
              />
            </div>
            <div className="w-[200px]">
              <DateInput
                placeholder="Select end date..."
              />
  </div>*/}
            </div>
            <div className="flex-1" ref={tableContainerRef}>
              {
                pageSize && data && (
                  <Table
                    isPaginated={true}
                    currentPage={pageIndex}
                    onPageChange={setPagination}
                    totalRowsCount={data ? data.pagination.totalDocs : 0}
                    pageRowCount={pageSize}
                    padToPageSize={true}
                    onRowClick={(row) => NiceModal.show('podsViewSignatureModal', { podId: row._id })}
                    dummyRowHeight={32}
                    thinRows
                    data={data ? data.response : []}
                    columns={[
                      {
                        header: 'DATE',
                        accessorKey: 'Date',
                        cellSize: 120,
                        cell: ({ row }) => moment(row.original.Date).format('DD/MM/YY HH:mm')
                      },
                      {
                        header: 'ACCT',
                        accessorKey: 'Acct',
                        cellSize: 20
                      },
                      {
                        header: 'NAME',
                        accessorKey: 'Name',
                        truncate: true,
                        cellSize: 250
                      },
                      {
                        header: 'DRIVER',
                        accessorKey: 'User',
                        cellSize: 100,
                      },
                      {
                        header: 'INVOICES',
                        accessorKey: 'document',
                        cell: ({ row }) => row.original.Document.join(', ')
                      },
                      /*{
                        header: '',
                        accessorKey: 'loc',
                        cellSize: 1,
                        cell: ({ row }) => (
                          <Button
                            variant="rounded"
                            tiny
                            onClick={() => NiceModal.show('podsViewMapModal', { name: row.original.User, lat: parseFloat(row.original.Lat), lon: parseFloat(row.original.Lon) })}
                            Icon={MapIcon}
                          />
                        )
                      },*/
                      {
                        header: '',
                        accessorKey: 'view',
                        cellSize: 1,
                        disableSortBy: true,
                        cellPad: false,
                        cell: ({ row }) => (
                          <Button
                            variant="rounded"
                            tiny
                            onClick={() => NiceModal.show('podsViewSignatureModal', { podId: row.original._id })}
                            Icon={PencilSquareIcon}
                          />
                        )
                      }
                    ]}
                  />
                )
              }
            </div>
          </div>
        </Card>
      </Col>
    </Grid>
  )
}

const CustomerDropdown = ({ value, onChange }) => {
  const { isLoading, isError, error, data } = usePodCustomers()

  return (
    <Dropdown
      placeholder="Select customer..."
      value={value}
      onChange={onChange}
      options={data || []}
      isClearable={true}
    />
  )
}

const DriverDropdown = ({ value, onChange }) => {
  const { isLoading, isError, error, data } = usePodDrivers()

  return (
    <Dropdown
      placeholder="Select driver..."
      value={value}
      onChange={onChange}
      options={data || []}
      isClearable={true}
    />
  )
}

export default Pods